import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi/useApi";
import { useNotification } from "~hooks/useNotification";
import type { DefaultOperationSuccessResponse } from "~types/response";
import type { UserTransformed } from "../../types";

const useDeleteUserPermission = () => {
  const { sport, organizationId, userId } = useParams();
  const { formatMessage } = useIntl();
  const queryClient = useQueryClient();
  const request = useApi();
  const notification = useNotification();

  return useMutation<DefaultOperationSuccessResponse, Error, number>({
    mutationFn: async (permissionId: number) => {
      return await request(`${sport}/o/${organizationId}/users/${userId}/permissions/${permissionId}`, {
        method: "DELETE",
      });
    },
    onSuccess: (response: DefaultOperationSuccessResponse, permissionId: number) => {
      if (response?.data[0]?.success) {
        queryClient.setQueryData<UserTransformed>(
          ["permission-users", sport, organizationId, userId],
          (oldUser: UserTransformed | undefined) => {
            if (oldUser) {
              return {
                ...oldUser,
                permissions: oldUser.permissions.filter((permission) => permission.permissionId !== permissionId),
              };
            }
          },
        );
        notification.success({
          message: formatMessage({
            id: "permissions.user.role.actions.delete.success",
          }),
          placement: "bottomRight",
        });
      }
    },
  });
};

export default useDeleteUserPermission;
